export const OnboardingSiteType = {
  Provision: `provision`,
  Create: `create`,
  DeployNow: `deployNow`,
}
